// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__22mCG","header":"ReportDetails_header__FCoLB","title":"ReportDetails_title__37mK4","left":"ReportDetails_left__3d9SE"};